import React from "react";

import Breadcrumbs from "../component/breadcrumbs";
import CustomHelmet from "../component/CustomHelmet";
import Intro from "../component/Intro";
import BaseContainer from "../component/layout/base-container";

export default function Thanks() {
  return (
    <>
      <CustomHelmet pageTitle="Danke" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Umfrage", url: "/umfrage" },
          { name: "Danke", url: `/danke` },
        ]}
      />
      <BaseContainer>
        <Intro title={"Danke"}>
          <p className="Intro--text">
            Danke für das Ausfüllen der Umfrage. Du kannst diese Seite jetzt
            schliessen.
          </p>
        </Intro>
      </BaseContainer>
    </>
  );
}
